import type { components } from '../../generated/api';

export type Purchase = components['schemas']['SubscriptionPurchase'];
export type Subscription = components['schemas']['Subscription'];
export type PurchaseOwner = { userId: string; origin: string; epoch: string };
export type PurchaseIntent = PurchaseOwner & { key: string; purchaseId?: string; outcome?: 'success' | 'failure' | 'cancel'; confirmKey?: string };
const INTENT_KEY = 'kazna:subscription-purchase:v1';
const UUID = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/iu;

export function getAccessDuration(value: Pick<Subscription, 'enabled' | 'status' | 'serverNow' | 'accessUntil'>): number {
  if (!value.enabled) return Infinity;
  if (!['TRIAL_ACTIVE', 'PAID_ACTIVE'].includes(value.status) || !value.accessUntil) return 0;
  const duration = Date.parse(value.accessUntil) - Date.parse(value.serverNow);
  return Number.isFinite(duration) ? Math.max(0, duration) : 0;
}

export function readPurchaseIntent(owner: PurchaseOwner): PurchaseIntent | undefined {
  try {
    const value = JSON.parse(localStorage.getItem(INTENT_KEY) ?? 'null') as PurchaseIntent | null;
    if (!value || value.userId !== owner.userId || value.origin !== owner.origin || value.epoch !== owner.epoch
      || typeof value.key !== 'string' || !UUID.test(value.key)
      || (value.purchaseId !== undefined && !UUID.test(value.purchaseId))
      || (value.confirmKey !== undefined && !UUID.test(value.confirmKey))
      || (value.outcome !== undefined && !['success', 'failure', 'cancel'].includes(value.outcome))) return;
    return value;
  } catch { return; }
}
export function savePurchaseIntent(intent: PurchaseIntent): void { localStorage.setItem(INTENT_KEY, JSON.stringify(intent)); }
export function clearPurchaseIntent(owner: PurchaseOwner): void { if (readPurchaseIntent(owner)) localStorage.removeItem(INTENT_KEY); }
